import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import AdminLayout from "../components/AdminLayout";
import AddCategoryModal from "../components/AddCategoriaModal";
import { IconPlus } from "@tabler/icons-react";

function CartasNovo() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    data_recebimento: "",
    local_recebimento: "",
    cpf: "",
    solicitante: "",
    sexo: "",
    telefone: "",
    endereco: "",
    bairro: "",
    zona: "",
    solicitacao: "",
    encaminhar: "",
    categoria_id: "",
    info_adicionais: "",
    observacao: "",
    status: "",
    carta_digital: "",
    itens_atendidos: []
  });

  const [categories, setCategories] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showCategoryModal, setShowCategoryModal] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;
  
    if (name === "telefone") {
      formattedValue = formatTelefone(value);
    }
    if (name === "data_recebimento") {
      formattedValue = formatData(value);
    }
    if (name === "cpf") {
      formattedValue = formatCPF(value);
    }
    
    setFormData({
      ...formData,
      [name]: formattedValue,
    });
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}cartas/categorias/`);
        if (res.ok) {
          const data = await res.json();
          setCategories(data);
        } else {
          console.error("Erro ao buscar categorias");
        }
      } catch (error) {
        console.error("Erro na requisição de categorias:", error);
      }
    };
    fetchCategories();
  }, [API_BASE_URL]);

  const handleCategoryAdded = (newCategory) => {
    setCategories([...categories, newCategory]);
    // Define o valor do select para o novo ID criado, se necessário
    setFormData({ ...formData, categoria: newCategory.id });
  };

  const formatTelefone = (value) => {
    value = value.replace(/\D/g, "");
    value = value.slice(0, 11);

    if (value.length <= 10) {
      return value
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{4})(\d)/, "$1-$2");
    } else {
      return value
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{5})(\d)/, "$1-$2");
    }
  };

 // Formats a date input (assumed digits only) into DD/MM/YYYY as the user types
const formatData = (value) => {
  // Remove non-digit characters and limit to 8 digits (DDMMYYYY)
  const digits = value.replace(/\D/g, "").substring(0, 8);
  let formatted = digits;
  if (digits.length >= 3) {
    formatted = digits.substring(0, 2) + "/" + digits.substring(2, 4);
  }
  if (digits.length >= 5) {
    formatted += "/" + digits.substring(4, 8);
  }
  return formatted;
};

const formatCPF = (value) => {
  // Remove todos os caracteres que não sejam dígitos
  value = value.replace(/\D/g, "");
  // Limita a 11 dígitos
  value = value.substring(0, 11);
  
  if (value.length > 9) {
    // Formata como 999.999.999-99
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, "$1.$2.$3-$4");
  } else if (value.length > 6) {
    // Formata como 999.999.999
    return value.replace(/(\d{3})(\d{3})(\d{0,3})/, "$1.$2.$3");
  } else if (value.length > 3) {
    // Formata como 999.999
    return value.replace(/(\d{3})(\d{0,3})/, "$1.$2");
  }
  return value;
};

const handleAddItem = () => {
  setFormData(prev => ({
    ...prev,
    itens_atendidos: [...prev.itens_atendidos, { quantidade: "", item: "" }]
  }));
};

const handleItemChange = (e, index, field) => {
  const updatedItens = [...formData.itens_atendidos];
  updatedItens[index] = { ...updatedItens[index], [field]: e.target.value };
  setFormData({ ...formData, itens_atendidos: updatedItens });
};

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  // Create a FormData object
  const formDataToSend = new FormData();
  
  // Append all the text fieldsåå
  formDataToSend.append("data_recebimento", formData.data_recebimento);
  formDataToSend.append("local_recebimento", formData.local_recebimento);
  formDataToSend.append("cpf", formData.cpf.replace(/\D/g, ""));
  formDataToSend.append("solicitante", formData.solicitante);
  formDataToSend.append("sexo", formData.sexo);
  // Remove formatting from telefone
  formDataToSend.append("telefone", formData.telefone.replace(/[^\d]/g, ""));
  formDataToSend.append("endereco", formData.endereco);
  formDataToSend.append("bairro", formData.bairro);
  formDataToSend.append("zona", formData.zona);
  formDataToSend.append("solicitacao", formData.solicitacao);
  formDataToSend.append("encaminhar", formData.encaminhar);
  formDataToSend.append("categoria_id", formData.categoria_id);
  formDataToSend.append("info_adicionais", formData.info_adicionais);
  formDataToSend.append("observacao", formData.observacao);
  formDataToSend.append("status", formData.status);
  formDataToSend.append("itens_atendidos", JSON.stringify(formData.itens_atendidos));

  if (formData.carta_digital) {
    const originalFile = formData.carta_digital;
    // Extrai a extensão do arquivo (por exemplo, "pdf")
    const extension = originalFile.name.split('.').pop();
    // Obtém o ano atual
    const currentYear = new Date().getFullYear();
    // Formata a data de recebimento para substituir barras por hífens
    const formattedDate = formData.data_recebimento.replace(/\//g, "-");
    // Constrói o novo nome usando solicitante, data (formatada) e ano atual
    const newFileName = `${formData.solicitante}_${formattedDate}_${currentYear}.${extension}`;
    // Cria um novo File com o novo nome
    const renamedFile = new File([originalFile], newFileName, { type: originalFile.type });
    formDataToSend.append("carta_digital", renamedFile);
  }

  try {
    const response = await fetch(`${API_BASE_URL}cartas/novo/`, {
      method: 'POST',
      body: formDataToSend,
    });

    if (response.ok) {
      setSuccessMessage("Carta cadastrada com sucesso!");
      setFormData({
        data_recebimento: "",
        local_recebimento: "",
        cpf:"",
        solicitante: "",
        sexo: "",
        telefone: "",
        endereco: "",
        bairro: "",
        zona: "",
        solicitacao: "",
        encaminhar: "",
        categoria_id: "",
        info_adicionais: "",
        observacao: "",
        status: "",
        carta_digital: "",
        itens_atendidos: []
      });
      
      setTimeout(() => {
        setSuccessMessage("");
        navigate("/cartas");
      }, 3000);
    } else {
      setErrorMessage("Falha ao cadastrar carta.");
    }
  } catch (error) {
    setErrorMessage("Ocorreu um erro ao enviar o formulário.");
  } finally {
    setIsSubmitting(false);
  }
};

  useEffect(() => {
    if (successMessage || errorMessage) {
        const timer = setTimeout(() => {
            setSuccessMessage("");
            setErrorMessage("");
        }, 5000); // 5 segundos
        return () => clearTimeout(timer);
    }
}, [successMessage, errorMessage]);

  return (
    <AdminLayout>
      <div>
          {successMessage && (
              <div className="alert alert-success alert-float">
                  {successMessage}
              </div>
          )}
          {errorMessage && (
              <div className="alert alert-danger alert-float">
                  {errorMessage}
              </div>
          )}
      </div>
      <div className="container mt-4">
        <div className="col-12">
          <form className="card" onSubmit={handleSubmit} disabled={isSubmitting}>
            <div className="card-body">
              <h3 className="card-title">Cadastro de Carta</h3>
              <div className="row row-cards">
                {/* Identificação do Beneficiario */}
                <h4 className="mt-4">1. Informações do Solicitante</h4>
                <div className="col-md-2">
                  <div className="mb-3">
                    <label className="form-label">Data de Recebimento</label>
                    <input type="text" className="form-control" name="data_recebimento" onChange={handleChange} value={formData.data_recebimento} />
                  </div>
                </div>
                <div className="col-md-10">
                  <div className="mb-3">
                    <label className="form-label">Local do Recebimento</label>
                    <input type="text" className="form-control" name="local_recebimento" onChange={handleChange} value={formData.local_recebimento} />
                  </div>
                </div>
                {formData.status === "resolvido" && (
                  <div className="col-md-2">
                    <div className="mb-3">
                      <label className="form-label">CPF</label>
                      <input
                        mask="999.999.999-99"
                        className="form-control"
                        name="cpf"
                        onChange={handleChange}
                        value={formData.cpf}
                        required
                      />
                    </div>
                  </div>
                )}
                <div className="col-md-10">
                  <div className="mb-3">
                    <label className="form-label">Solicitante</label>
                    <input type="text" className="form-control" name="solicitante" onChange={handleChange} value={formData.solicitante} />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-3">
                    <label className="form-label">Sexo</label>
                    <select
                      className="form-select"
                      name="sexo"
                      onChange={handleChange}
                      value={formData.sexo}
                    >
                      <option value="" disabled>Selecione...</option>
                      <option value="masculino">Masculino</option>
                      <option value="feminino">Feminino</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-3">
                    <label className="form-label">Telefone</label>
                    <input
                      type="text"
                      className="form-control"
                      name="telefone"
                      onChange={handleChange}
                      value={formData.telefone}
                    />
                  </div>
                </div>
                <div className="col-md-10">
                  <div className="mb-3">
                    <label className="form-label">Endereço</label>
                    <input type="text" className="form-control" name="endereco" onChange={handleChange} value={formData.endereco} />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Bairro</label>
                    <input type="text" className="form-control" name="bairro" onChange={handleChange} value={formData.bairro} />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-3">
                    <label className="form-label">Zona</label>
                    <select
                      className="form-select"
                      name="zona"
                      onChange={handleChange}
                      value={formData.zona}
                    >
                      <option value="" disabled>Selecione...</option>
                      <option value="sem_endereco">Sem Endereço</option>
                      <option value="norte">Norte</option>
                      <option value="sul">Sul</option>
                      <option value="leste">Leste</option>
                      <option value="oeste">Oeste</option>
                      <option value="centrooeste">Centro Oeste</option>
                      <option value="centrosul">Centro Sul</option>
                      <option value="rural">Rural</option>
                    </select>
                  </div>
                </div>
                
                {/* Informações da Solicitação */}
                <h4 className="mt-4">2. Informações da Solicitação</h4>
                <div className="col-md-8">
                  <div className="mb-3">
                    <label className="form-label">Solicitação</label>
                    <input type="text" className="form-control" name="solicitacao" onChange={handleChange} value={formData.solicitacao} />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label">Categoria</label>
                    <select
                      className="form-select"
                      name="categoria_id"
                      onChange={(e) => setFormData({ ...formData, categoria_id: e.target.value })}
                      value={formData.categoria_id}
                    >
                      <option value="" disabled>Selecione...</option>
                      {categories.map((cat) => (
                        <option name='categoria_id' key={cat.id} value={cat.id}>{cat.nome}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-1">
                  <div className="mb-3">
                  <label className="form-label text-white">.</label>
                  <button
                      type="button"
                      className="btn btn-teal"
                      onClick={() => setShowCategoryModal(true)}
                      aria-label="Adicionar nova categoria"
                    >
                      <IconPlus size={20} />
                    </button>
                  </div>
                </div>
                <div className="col-md-10">
                  <div className="mb-3">
                    <label className="form-label">Encaminhar</label>
                    <input type="text" className="form-control" name="encaminhar" onChange={handleChange} value={formData.encaminhar} />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-3">
                    <label className="form-label">Grau de Urgência</label>
                    <select
                      className="form-select"
                      name="urgencia"
                      onChange={handleChange}
                      value={formData.urgencia}
                    >
                      <option value="">Selecione...</option>
                      <option value="alta">Alta</option>
                      <option value="media">Média</option>
                      <option value="baixa">Baixa</option>
                    </select>
                  </div>
                </div>
                {formData.status === "resolvido" && (
                  <div>
                    <h4 className="mt-4">Itens Atendidos</h4>
                    <div className="table-responsive mt-4">
                      <table className="table mb-0">
                        <thead>
                          <tr>
                            <th>Quantidade</th>
                            <th>Item</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData.itens_atendidos.map((it, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  type="number"
                                  name={`quantidade_${index}`}
                                  className="form-control"
                                  value={it.quantidade}
                                  onChange={(e) => handleItemChange(e, index, 'quantidade')}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  name={`item_${index}`}
                                  className="form-control"
                                  value={it.item}
                                  onChange={(e) => handleItemChange(e, index, 'item')}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <button type="button" className="btn btn-teal mt-2" onClick={handleAddItem}>
                      <IconPlus size={20} />
                    </button>
                  </div>
                )}


                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Informações Adicionais</label>
                    <input type="text" className="form-control" name="info_adicionais" onChange={handleChange} value={formData.info_adicionais} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Observação</label>
                    <input type="text" className="form-control" name="observacao" onChange={handleChange} value={formData.observacao} />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select
                      className="form-select"
                      name="status"
                      onChange={handleChange}
                      value={formData.status}
                    >
                      <option value="" disabled>Selecione...</option>
                      <option value="inexecutavel">Inviável</option>
                      <option value="pendente">Pendente</option>
                      <option value="resolvido">Resolvido</option>
                    </select>
                  </div>
                </div>
                <h4 className="mt-4">3. Carta Digitalizada</h4>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Arquivo digitalizado</label>
                    <input
                        id="carta_digital"
                        type="file"
                        className="form-control"
                        name="carta_digital"
                        accept="application/pdf"
                        onChange={(e) =>
                          setFormData({ ...formData, carta_digital: e.target.files[0] })
                        }
                      />
                      {formData.carta_digital && (
                        <div className="form-control is-valid text-success mt-2">
                          Arquivo carregado com sucesso e pronto para upload!
                        </div>
                      )}
                    </div>
                </div>
              </div>
            </div>
            <div className="card-footer text-end">
              <button type="button" className="btn btn-secondary me-2" onClick={() => setFormData({})}>
                Cancelar
              </button>
              <button type="submit" disabled={isSubmitting} className="btn btn-primary">Salvar</button>
            </div>
          </form>
        </div>
      </div>
      
      <AddCategoryModal
        show={showCategoryModal}
        handleClose={() => setShowCategoryModal(false)}
        onCategoryAdded={handleCategoryAdded}
        API_BASE_URL={API_BASE_URL}
      />
    </AdminLayout>
  );
}

export default CartasNovo;